module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABUgAAAACCAYAAACKeTYPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVRoge3OQQEAIAwEoJu5bK+F1sAYewgJqO4+SXYAAAAAAP5y1/QAAAAAAGBIPRzPBJvlFquKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/graduateSchool/4-4.png
// module id = /GQE
// module chunks = 1